













































import { Component } from 'vue-property-decorator';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { NavIndiRefDimention } from './types';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';

@Component({
  components: {
    SwIcon,
  },
})
export default class NavIndicator extends SwExtendedVue {
  readyToShow: boolean = false;
  /**
   * Intended not to use prop but use instance method to pass this value, in order to avoid rendering loop
   */
  refDimention: NavIndiRefDimention | null = null;

  get posStyle() {
    if (!this.readyToShow || !this.refDimention) { return {}; }
    const el = this.$el as HTMLElement;
    // console.warn(`dim left: ${this.refDimention.left}`);
    // console.warn(`width: ${el.offsetWidth}, height: ${el.offsetHeight}`);
    return {
      left: `${this.refDimention.left - el.offsetWidth}px`,
      top: `${this.refDimention.top + (this.refDimention.height / 2) - (el.offsetHeight / 2) - 1}px`,
    };
  }

  updateRefDimention(refDim: NavIndiRefDimention) {
    this.refDimention = refDim;
  }

  mounted() {
    this.$nextTick(() => {
      this.readyToShow = true;
    });
  }
}
